// extracted by mini-css-extract-plugin
export default {"highlight":"_0HSgdWiCeYe1ac1iDdkWrQ=="};